<div class="radio-button-container">
	<!-- TODO: Add FORM CONTROL NAME -->
	<mat-radio-group aria-label="">
		<mat-radio-button
				*ngFor="let item of this.items"
				[value]=item
				(click)=selectValue(item)>{{ item | translate }}</mat-radio-button>
	</mat-radio-group>
</div>
